// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_96-4";
export var collapsed = "_96-1";
export var headerBar = "_96-0";
export var leftHeaderContent = "_96-3";
export var subjectContainer = "_96-2";